import { Outlet, Navigate } from 'react-router-dom'

import useAuth from '../hooks/useAuth'
const ProtectedRoute = () => {
  const { loading, userRegister } = useAuth()

  if (!loading) {
    return
  }

  return (
    <>
      { userRegister
        ? (
          <Outlet />
        )
        : (
          <Navigate to="/" />
        )}
    </>
  )
}

export default ProtectedRoute
